import { CountryCode } from '~shared/constants/country-code.enum';

const metroLogo = 'metro-logo';
const makroLogo = 'makro-logo';

export const HEADER_LOGO_NAME = {
  [CountryCode.Germany]: metroLogo,
  [CountryCode.Spain]: makroLogo,
  [CountryCode.Italy]: metroLogo,
  [CountryCode.Portugal]: makroLogo,
  [CountryCode.Netherlands]: makroLogo,
  [CountryCode.France]: metroLogo
};
